module.exports = __webpack_public_path__ + "img/Image_1__First_Canal_985_5_208_inside.c60d4325.jpg";